export const Contact = (props) => {
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <p>
                      <span>
                        <i className='fa fa-envelope-o'></i>
                      </span>{' '}
                      <a href={`mailto:${props.data ? props.data.email : ''}`}>
                        {props.data ? props.data.email : 'loading'}
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        <i className='fa fa-phone'></i>
                      </span>{' '}
                      <a href={`tel:${props.data ? props.data.phone : ''}`}>
                        {props.data ? props.data.phone : 'loading'}
                      </a>
                    </p>
                  </li>
                  <li>
                    <a href={props.data ? props.data.facebook : '/'}>
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : '/'}>
                      <i className='fa fa-youtube'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}